<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://coreui.io" target="_blank">IFGF PORTAL</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} IFGF Developer Team.</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
